import { useContext } from 'react';
import { AddressContext } from '../contexts/address-context';

export const useAddress = () => {
  const context = useContext(AddressContext);
  if (!context) {
    throw new Error('useAddress must be used within a Address Provider');
  }
  return context;
};
